import { render, staticRenderFns } from "./XTableBody.vue?vue&type=template&id=e117ee2a&"
import script from "./XTableBody.vue?vue&type=script&lang=js&"
export * from "./XTableBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports